import * as React from 'react';
import { LinkButton, UIHeading2 } from '@cian/ui-kit';
import * as style from './style.css';

interface IPromoOffersListingCardProps {
  onListingClick(): void;
  url: string;
}

export const PromoOffersListingCard = ({ url, onListingClick }: IPromoOffersListingCardProps) => {
  return (
    <div onClick={onListingClick} className={style['container']} data-testid="PromoOffersListingCard">
      <a className={style['link-area']} href={url} target="_blank" rel="noreferrer" />
      <div className={style['content']}>
        <div className={style['logo']} />
        <UIHeading2>
          Все подходящие объявления <br />с акциями
        </UIHeading2>
      </div>
      <LinkButton fullWidth>Посмотреть</LinkButton>
    </div>
  );
};
